import { Cloudinary } from 'cloudinary-core';
import getDevicePixelRatio from './getDevicePixelRatio';

const cloudinary = new Cloudinary({
  secure: true,
});

const getOptimizedUrl = ({
  publicId,
  cloudName,
  resourceType,
  height,
  width,
  format,
  crop = 'fill_pad',
}) =>
  cloudinary.url(publicId, {
    cloud_name: cloudName,
    type: 'upload',
    resource_type: resourceType,
    crop: crop,
    gravity: 'auto',
    height,
    width,
    dpr: getDevicePixelRatio(),
    quality: 'auto',
    fetch_format: 'auto',
    format,
  });

export default getOptimizedUrl;
